/*
  ths-legacy-ui.js — vanilla replacements for the legacy jQuery block that used to
  live inline at the bottom of layout/theme.liquid.

  Ported so the jQuery CDN bundle could be dropped from <head> (see theme.liquid).
  Every behaviour below was verified as live on the storefront before porting:
  FAQ accordions, header menu hover, show more/less, read more/less, footer
  accordions and the rotating search placeholder.

  Note: the FAQ and extra-content open/closed states are already driven by CSS
  (`.faq-answer { display:none }` + `.faq-item.active .faq-answer { display:block }`,
  `.all_cont_imh .extra_content { display:none }`), so this file only manages
  classes and lets the stylesheet do the showing/hiding. jQuery's slideToggle used
  to fight that CSS by writing inline display values.
*/
(function () {
  'use strict';

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  /* ---- slide helpers (stand-ins for jQuery slideDown / slideUp) ---- */

  function slideDown(el, duration) {
    if (!el) return;
    el.style.removeProperty('display');
    var display = window.getComputedStyle(el).display;
    if (display === 'none') display = 'block';
    el.style.display = display;

    var target = el.scrollHeight;
    el.style.overflow = 'hidden';
    el.style.height = '0px';
    el.style.transition = 'height ' + duration + 'ms ease';
    // force reflow so the transition starts from 0
    el.offsetHeight; // eslint-disable-line no-unused-expressions
    el.style.height = target + 'px';

    window.setTimeout(function () {
      el.style.removeProperty('height');
      el.style.removeProperty('overflow');
      el.style.removeProperty('transition');
    }, duration);
  }

  function slideUp(el, duration) {
    if (!el) return;
    el.style.overflow = 'hidden';
    el.style.height = el.scrollHeight + 'px';
    el.style.transition = 'height ' + duration + 'ms ease';
    el.offsetHeight; // eslint-disable-line no-unused-expressions
    el.style.height = '0px';

    window.setTimeout(function () {
      el.style.display = 'none';
      el.style.removeProperty('height');
      el.style.removeProperty('overflow');
      el.style.removeProperty('transition');
    }, duration);
  }

  /* ---- rotating search placeholder ---- */

  function initSearchTyping() {
    var input = document.querySelector('.search-with-suggestions input');
    var holder = document.querySelector('.search-placeholder-text');
    if (!input || !holder) return;

    var phrases = [];
    try {
      phrases = JSON.parse(input.getAttribute('data-phrases') || '[]');
    } catch (e) {
      phrases = [];
    }
    if (!phrases.length) return;

    var index = 0;
    var rotateTimer = null;
    var typeTimer = null;
    var typingSpeed = 80;

    function typeText(text) {
      holder.textContent = '';
      var span = document.createElement('span');
      span.className = 'typed';
      holder.appendChild(span);

      var charIndex = 0;
      (function typeChar() {
        if (charIndex <= text.length) {
          span.textContent = text.substring(0, charIndex);
          charIndex++;
          typeTimer = window.setTimeout(typeChar, typingSpeed);
        }
      })();
    }

    function rotate() {
      typeText(phrases[index % phrases.length]);
      index++;
    }

    function startRotation() {
      rotate();
      rotateTimer = window.setInterval(rotate, 8000);
    }

    function stopRotation() {
      window.clearInterval(rotateTimer);
      window.clearTimeout(typeTimer);
      var typed = holder.querySelector('.typed');
      if (typed) typed.remove();
    }

    startRotation();
    input.addEventListener('focus', stopRotation);
    input.addEventListener('blur', startRotation);
  }

  /* ---- FAQ accordions ----
     Matches the old jQuery chain: toggle `active` on the clicked question and its
     wrapper, and close every sibling wrapper. */

  // event.target can be a non-Element (e.g. a text node in some engines), so
  // every delegated handler goes through this instead of calling closest() blind.
  function closestFrom(event, selector) {
    var node = event.target;
    if (!node || typeof node.closest !== 'function') return null;
    return node.closest(selector);
  }

  function initFaq(questionSelector) {
    document.addEventListener('click', function (event) {
      var question = closestFrom(event, questionSelector);
      if (!question) return;

      var item = question.parentElement;
      if (!item) return;

      var wasOpen = item.classList.contains('active');

      var siblings = item.parentElement
        ? Array.prototype.slice.call(item.parentElement.children)
        : [];
      siblings.forEach(function (sibling) {
        if (sibling === item) return;
        sibling.classList.remove('active');
        var siblingQuestion = sibling.querySelector(questionSelector);
        if (siblingQuestion) siblingQuestion.classList.remove('active');
      });

      item.classList.toggle('active', !wasOpen);
      question.classList.toggle('active', !wasOpen);
    });
  }

  /* ---- header menu: open on hover ---- */

  function initMenuHover(id) {
    var details = document.getElementById(id);
    if (!details) return; // guarded: the old inline code threw here when absent
    details.addEventListener('mouseenter', function () {
      details.setAttribute('open', 'hovered');
    });
    details.addEventListener('mouseleave', function () {
      details.removeAttribute('open');
    });
  }

  /* ---- show more / show less ---- */

  function initShowMore() {
    var button = document.getElementById('show_more_less');
    var extra = document.querySelector('.extra_content');
    if (!button || !extra) return;

    button.addEventListener('click', function () {
      if (button.classList.contains('hide1')) {
        slideDown(extra, 800);
        button.classList.remove('hide1');
        button.classList.add('show1');
        button.textContent = 'show less';
      } else {
        slideUp(extra, 800);
        button.classList.remove('show1');
        button.classList.add('hide1');
        button.textContent = 'show more';
      }
    });
  }

  /* ---- read more / read less on long descriptions ---- */

  function initReadMore() {
    // Queried at click time, not at init — matches the original jQuery, and keeps
    // working if the description is re-rendered (variant swap, slab quantity change).
    document.addEventListener('click', function (event) {
      if (closestFrom(event, '.readmore')) {
        var shortEl = document.querySelector('.des_short');
        if (shortEl) shortEl.style.display = 'none';
        slideDown(document.querySelector('.des_full'), 800);
        return;
      }
      if (closestFrom(event, '.readless')) {
        slideUp(document.querySelector('.des_full'), 800);
        window.setTimeout(function () {
          var s = document.querySelector('.des_short');
          if (s) s.style.removeProperty('display');
        }, 850);
      }
    });
  }

  /* ---- footer accordions ---- */

  function initFooterAccordions() {
    document.addEventListener('click', function (event) {
      var heading = closestFrom(event, '.footer-block__heading');
      if (!heading) return;
      var parent = heading.parentElement;
      if (!parent) return;
      var content = parent.querySelector('.footer-block__details-content');
      if (content) content.classList.toggle('active');
      heading.classList.add('add');
    });
  }

  onReady(function () {
    initSearchTyping();
    initFaq('.faq-question');
    initFaq('.faq-question-ac');
    initMenuHover('Details-HeaderMenu-7');
    initMenuHover('Details-HeaderMenu-5');
    initShowMore();
    initReadMore();
    initFooterAccordions();
  });
})();
